import {ChangeDetectorRef, Component, HostListener, OnInit} from '@angular/core';
import {VssLoadingService} from '../vss-loading.service';

@Component({
  selector: 'vss-ui-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  showLoading = false;
  constructor(
    private loadingService: VssLoadingService,
    private cdref: ChangeDetectorRef
  ) { }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  ngOnInit() {
    this.loadingService.loadingSubject.pipe().subscribe(isLoading => {
      this.showLoading = isLoading;
      this.cdref.detectChanges();
    });
  }
}
